import React, { Component } from 'react';
import {Head, withRouteData} from 'react-static';

import Header from '../components/Header';
import Outro from '../components/Outro';
import Footer from '../components/Footer';
import EconomyComponent from '../components/Economy';
import SocialLinks from "../components/SocialLinks";

class Economy extends Component {
	render() {
		return (
			<div>
				<Head>
					<title>Invest in Innovative Technologies | Digital Technology | CTR Group</title>
					<meta name="description" content="CTR is an effective opportunity for solving the problem of digital inequality, with a projected increase of cost by 4.5 times, in the first year of the project" />
				</Head>
				<Header />
				<EconomyComponent />
				<Outro />
				<SocialLinks />
				<Footer />
			</div>
		)
	}
}

export default withRouteData(Economy)


// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Economy.js